import * as React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const MulticolImage = ({ image, alt, caption }) => (
  <figure>
    <GatsbyImage image={getImage(image.asset)} alt={alt} />
  </figure>
)

export default MulticolImage
